import React from 'react';
import PropTypes from 'prop-types';
import {tabType, getNavigationImageSrc} from '../../../utils/editorUtils';
import { Tooltip} from '@mui/material';
import {makeStyles} from '@mui/styles'
import clsx from 'clsx';
import navigatorInFolderSrc from '../../../assets/images/editor/navigation/in_folder.gif'
import SMCIcon from '../../Simple/SMCIcon';
import SMCHighlighter from '../../Simple/SMCHighlighter';

function EditorSidebarTab({
    hide,
    first,
    last,
    inFolder,
    inLastFolder,
    selectedId,
    onChoose,
    id,
    icon,
    title,
    extraIcon,
    onSelectPage,
    hasError,
    errorMessages,
    highlightText
}) {
    const classes = useStyles();

    const selected = (selectedId === id) || (selectedId === null && !inFolder && first);

    let navigatorImgSrc;
    let tabTypeBase = inFolder ? tabType.IN_FOLDER : tabType.NORMAL;

    if (first) {
        navigatorImgSrc = getNavigationImageSrc(tabTypeBase.FIRST);
    } else if (last) {
        navigatorImgSrc = getNavigationImageSrc(tabTypeBase.LAST);
    } else {
        navigatorImgSrc = getNavigationImageSrc(tabTypeBase.MIDDLE);
    }

    const onChooseText = () => {
        onSelectPage(id);
        onChoose && onChoose();
    }

    return (
        <div style={{ display: hide ? 'none' : 'flex' }}>
            {
                inFolder && (
                    <div style={{ width: 16 }}>
                        {
                            !inLastFolder && (
                                <img alt="" src={navigatorInFolderSrc} className={classes.navigationImage} />
                            )
                        }
                    </div>
                )
            }
            <div >
                <table cellSpacing="0" cellPadding="0" className={classes.tabRoot}>
                    <tbody>
                    <tr>
                        <td className={classes.imageCell}>
                            <img alt="" src={navigatorImgSrc} className={classes.navigationImage} />
                        </td>
                        <td className={classes.imageCell}>
                            <img alt="" src={icon} className={classes.displayIcon} />
                        </td>
                        <td onClick={onChooseText}>
                            <span className={clsx(classes.defaultTab, selected && classes.selectedTab)} style={{ width: inFolder ? 144 : 160 }}>
                                { extraIcon && <img src={extraIcon} alt="" className={classes.extraIcon} />}
                                <SMCHighlighter
                                    style={{ width: 140 - (extraIcon ? 20 : 0) - (inFolder ? 16 : 0) }}
                                    highlight={highlightText}
                                    text={title}
                                />
                                {
                                    hasError && (
                                        <Tooltip
                                            placement="bottom-start"
                                            title={errorMessages && (
                                                <div style={{ fontSize: '12px' }}>
                                                    {errorMessages.map((msg, index) => <React.Fragment key={index}>{msg}<br /></React.Fragment>)}
                                                </div>
                                            )}
                                        >
                                            <div>
                                                <SMCIcon icon="warning" className={classes.warningIcon} />
                                            </div>
                                        </Tooltip>
                                    )
                                }
                            </span>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
}

const useStyles = makeStyles({
    tabRoot: {
        padding: '14px 0 0 0',
        margin: '0'
    },
    imageCell: {
        width: '18px',
        height: '18px',
    },
    navigationImage: {
        padding: '0',
        margin: '0',
        verticalAlign: "middle"
    },
    displayIcon: {
        padding: '0',
        margin: '0',
        width: '16px',
        height: '16px'
    },
    extraIcon: {
        paddingRight: '4px',
        paddingTop: '4px',
        verticalAlign: 'middle',
        width: '10px',
        height: '10px'
    },
    warningIcon: {
        height: '16px',
        width: '16px',
    },
    defaultTab: {
        fontFamily: 'Open Sans',
        fontSize: '10pt',
        userSelect: 'none',
        cursor: 'pointer',
        padding: '5px 5px 0px 5px',
        textAlign: 'start',
        display: 'inline-flex',
        margin: '0',
        textDecoration: 'none !important',
        minHeight: '23px',
        '&:hover': {
            backgroundColor: '#e0e4e8'
        }
    },
    selectedTab: {
        backgroundColor: '#bce3fe !important'
    }
});

EditorSidebarTab.propTypes = {
    hide: PropTypes.bool,
    first: PropTypes.bool,
    last: PropTypes.bool,
    inFolder: PropTypes.bool,
    inLastFolder: PropTypes.bool,
    selectedId: PropTypes.string,
    onChoose: PropTypes.func,
    extraIcon: PropTypes.string,
    onSelectPage: PropTypes.func,
    id: PropTypes.string.isRequired,
    icon: PropTypes.string,
    title: PropTypes.string.isRequired
}

export default React.memo(EditorSidebarTab);